import { ReactElement, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import Snackbar from 'components/Snackbar'

interface IPartnersEmailSendNotificationProps {
  onClose: () => void
}

export const PartnersEmailSendNotification = ({ onClose }: IPartnersEmailSendNotificationProps): ReactElement => {
  useEffect((): void => {
    setTimeout((): void => {
      onClose()
    }, 5 * 1000)
  }, [])

  return (
    <Snackbar.Container>
      <Snackbar.Content>
        <FormattedMessage
          id="paymentSummary.sent.emails.message"
          defaultMessage="The payment summary emails were sent"
        />
      </Snackbar.Content>

      <Snackbar.Action onClick={onClose}>
        <FormattedMessage id="paymentSummary.sent.emails.action" defaultMessage="Close" />
      </Snackbar.Action>
    </Snackbar.Container>
  )
}
